import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import en from '../i18n/en.json';
import id from '../i18n/id.json';

const translations = { en, id };
const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('seikat_lang');
    if (saved === 'id' || saved === 'en') return saved;
    return null; // user has not chosen yet — Language Gate will prompt
  });

  useEffect(() => {
    if (lang) {
      localStorage.setItem('seikat_lang', lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const t = useCallback((key) => {
    const active = lang || 'id';
    const keys = key.split('.');
    let val = translations[active];
    for (const k of keys) {
      val = val?.[k];
    }
    return val || key;
  }, [lang]);

  const toggleLang = useCallback(() => {
    setLang(prev => (prev === 'en' ? 'id' : 'en'));
  }, []);

  const value = {
    lang: lang || 'id',
    language: lang || 'id',     // alias for new pages
    languageReady: !!lang,       // false until user chooses
    setLang,
    setLanguage: setLang,        // alias
    t,
    toggleLang
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
